import { useEffect, useState } from "react";

export function CountdownTimer({ duration }: { duration: number }) {
  const [seconds, setSeconds] = useState(duration);

  useEffect(() => {
    if (seconds === 0) {
      return;
    }
    const interval = setInterval(() => {
      setSeconds((prev) => prev - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, [seconds]);

  const formattedTime = `${String(Math.floor(seconds / 60)).padStart(2, "0")}:${String(seconds % 60).padStart(2, "0")}`;

  const strokeWidth = 6;
  const gapWidth = 4;
  const outerRadius = 72;
  const innerRadius = outerRadius - strokeWidth - gapWidth;

  const circumference = 2 * Math.PI * outerRadius;
  const offset = circumference * (1 - seconds / duration);

  return (
    <svg role="img" aria-label="Countdown timer" className="size-48">
      <circle cx="50%" cy="50%" r={outerRadius} fill="transparent" stroke="#3C7189" strokeWidth={strokeWidth} />
      <circle
        cx="50%"
        cy="50%"
        r={outerRadius}
        fill="transparent"
        stroke="#14DBC0"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        style={{
          transform: "rotate(-90deg)",
          transformOrigin: "center",
        }}
      />
      <circle cx="50%" cy="50%" r={innerRadius} fill="#3C7189" />
      <text
        x="50%"
        y="50%"
        dominantBaseline="middle"
        textAnchor="middle"
        fill="white"
        fontFamily="Montserrat Variable"
        fontSize="2rem"
        fontWeight={500}
      >
        {formattedTime}
      </text>
    </svg>
  );
}
